import {
  Ellipsis,
  FileDown,
  History,
  LayoutGrid,
  Palette,
  Pencil,
  Share2,
  Star,
} from 'lucide-react-native';
import { memo, useState } from 'react';
import { BiButton } from '../components/ui/BiButton';
import { BiMenuRow } from '../components/ui/BiMenuRow';
import { BiMenuSheet } from '../components/ui/BiMenuSheet';

/**
 * On a phone, the header's secondary actions behind a ⋯: the same ones,
 * in the same order, the wide header shows as buttons. A viewer who may
 * not edit sees 设为默认 and 导出 PDF only.
 */
export const DashboardMoreMenu = memo(
  ({
    title,
    canEdit,
    canManage,
    onReset,
    onHistory,
    onPalette,
    onRename,
    onShare,
    onSetDefault,
    onExport,
  }: {
    title: string;
    canEdit: boolean;
    canManage: boolean;
    onReset: (() => void) | null;
    onHistory: () => void;
    onPalette: () => void;
    onRename: () => void;
    onShare: () => void;
    onSetDefault: (() => void) | null;
    /** For every viewer once the dashboard is loaded: it as a PDF. */
    onExport: (() => void) | null;
  }) => {
    const [open, setOpen] = useState(false);
    return (
      <>
        <BiButton
          icon={Ellipsis}
          accessibilityLabel="更多操作"
          onPress={() => setOpen(true)}
        />
        <BiMenuSheet
          visible={open}
          title={title}
          onClose={() => setOpen(false)}
        >
          {run => (
            <>
              {onSetDefault ? (
                <BiMenuRow
                  icon={Star}
                  label="设为默认"
                  onPress={run(onSetDefault)}
                />
              ) : null}
              {onExport ? (
                <BiMenuRow
                  icon={FileDown}
                  label="导出 PDF"
                  onPress={run(onExport)}
                />
              ) : null}
              {!canEdit ? null : (
                <>
                  {onReset ? (
                    <BiMenuRow
                      icon={LayoutGrid}
                      label="重置布局"
                      onPress={run(onReset)}
                    />
                  ) : null}
                  <BiMenuRow
                    icon={Palette}
                    label="配色"
                    onPress={run(onPalette)}
                  />
                  <BiMenuRow
                    icon={History}
                    label="修改记录"
                    onPress={run(onHistory)}
                  />
                  {canManage ? (
                    <>
                      <BiMenuRow
                        icon={Pencil}
                        label="重命名"
                        onPress={run(onRename)}
                      />
                      <BiMenuRow
                        icon={Share2}
                        label="共享"
                        onPress={run(onShare)}
                      />
                    </>
                  ) : null}
                </>
              )}
            </>
          )}
        </BiMenuSheet>
      </>
    );
  },
);
